import { render, staticRenderFns } from "./partnership.vue?vue&type=template&id=62a0af1f&scoped=true&"
import script from "./partnership.vue?vue&type=script&lang=js&"
export * from "./partnership.vue?vue&type=script&lang=js&"
import style0 from "./partnership.vue?vue&type=style&index=0&id=62a0af1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a0af1f",
  null
  
)

export default component.exports